<template>
  <div 
  class="TideCard" 
  id="TideCard" 
  ref="tidecard" 
  v-bind:data-inspectmode="inspectMode" 
  v-bind:data-dragging="dragging" 
  @touchstart=touchstart 
  @touchmove=touchmove 
  @touchend=touchend>

  <!-- <MonthSwitcher @update-chosenmonth="updateChosenMonth"/> -->

    <div class="TideCardInner">
      <div class="Anchor" v-bind:data-loading="awaitingMonthData" v-bind:data-inspectmode="inspectMode">
        <div class="imgContainer Bottom" id="swimmer1">
          <img src="@/assets/images/person1.svg" alt="swimmer">
        </div>
        <!-- <div class="imgContainer" id="swimmer2">
          <img src="@/assets/images/person4-xmas.svg" alt="swimmer">
        </div> -->
        <div class="imgContainer Bottom" id="swimmer3">
          <img src="@/assets/images/person3.svg" alt="swimmer">
        </div>
        <div class="imgContainer" id="swimmer4">
          <img src="@/assets/images/person4.svg" alt="swimmer">
        </div>
        <!-- <div class="imgContainer" id="swimmer5">
          <img src="@/assets/images/cakegal.svg" alt="swimmer">
        </div> -->
        <div class="imgContainer" id="swimmer6">
          <img src="@/assets/images/desktop_person1.svg" alt="swimmer">
        </div>
        <div class="imgContainer" id="swimmer7">
          <img src="@/assets/images/desktop_person2.svg" alt="swimmer">
        </div>
        <div class="imgContainer" id="swimmer8">
          <img src="@/assets/images/desktop_person3.svg" alt="swimmer">
        </div>
        <div class="imgContainer" id="swimmer9">
          <img src="@/assets/images/desktop_person4.svg" alt="swimmer">
        </div>
          <!-- <div class="imgContainer" id="swimmer10">
          <img src="@/assets/images/desktop_person8.svg" alt="swimmer">
        </div> -->
      </div>

      <div class="TitleBlock" v-bind:data-inspectmode="inspectMode">
        <span class="Header OffWhite" v-if="inspectMode">High Tides</span>
        <span class="Header Yellow">{{ location.name }}</span>
        <span class="Header MidBlue" v-if="!inspectMode" v-html=getTodayAsString()></span>
        <span class="Header MidBlue" v-if="inspectMode">{{chosenMonthAsString}}</span>
        

        <span v-if="!inspectMode">
          <span class="TodaysTide OffWhite" v-if="todaysTides && todaysTides[0] && !awaitingTodaysData">{{todaysTides[0]}}</span>
          <span class="TodaysTide OffWhite" v-if="todaysTides && todaysTides[1] && !awaitingTodaysData">,&nbsp;{{todaysTides[1]}}</span>
          <span class="Loading" v-if="awaitingTodaysData">Checking tides...</span>
          
          <div class="MoonDescription" v-if="!awaitingTodaysData">
            <img v-bind:src="getMoonUrl(moonPhaseIndex)">
            <p>{{ moonPhases[moonPhaseIndex] }}</p>
            
          </div>     
        </span>
      </div>

      <div class="CalendarContainer">
        <div class="WeekTopLine Yellow" v-if="!awaitingMonthData">
          <span class="DayOfWeek">Sun</span>
          <span class="DayOfWeek">Mon</span>
          <span class="DayOfWeek">Tue</span>
          <span class="DayOfWeek">Wed</span>
          <span class="DayOfWeek">Thu</span>
          <span class="DayOfWeek">Fri</span>
          <span class="DayOfWeek">Sat</span>
        </div>
        <div class="DayGridContainer" v-if="!awaitingMonthData">
          <div class="DayItem" v-for="n in startDay" :key="n">
            <span class="DayIndex"></span>
            <span class="TideTime"></span>
          </div>
          <div v-for="(item, index) in days" :key="item" class="DayItem" :data-flash= this.isToday(index)>
            <span class="IndexContainer">
              <span class="DayIndex MidBlue">{{ index >= 10 ? index : `0${index}` }}</span>
              <img v-bind:src="getMoonUrl(item.moonPhase)">
            </span>
            
            <span class="TideTime OffWhite">{{ item.highs[0] }}</span>
            <span v-if="item.highs[1]" class="TideTime">{{
              item.highs[1]
            }}</span>
          </div>
                       
        </div>
        <div v-if="awaitingMonthData" class="LoadingSwimmer">
          <img src="@/assets/images/sealanimation.gif" alt="loading">
          <!-- <img src="@/assets/images/swimmeranimation-xmas.gif" alt="loading"> -->
        </div>
      </div>
    </div>

    <!-- <div class="sponsorContainer">
      <img src="@/assets/images/sponsorSHIP6.svg" alt="Support High Tides" v-bind:data-inspectmode="inspectMode" v-on:click=goToSponsor>
    </div> -->

    <!-- <div class="CalendarOfferContainer" v-if="!inspectMode">
        <div class="CalImageContainer">
          <img src="@/assets/images/tiny_calendar.svg" alt="Calendar">
        </div>
        <div class="CalInfoContainer">
          <h4>12-Month Seapoint Printed Calendar</h4>
          <a href="https://macaree.ie/shop" target="_blank">
            <button>Order Now</button>
          </a>
        </div>
      </div> -->

  </div>
</template>

<script>

export default {
    name: 'TideCard',
    props: {
      location: Object,
      inspectMode: Boolean,
    },
    created(){
      this.getTodaysTides();  
    },
    watch: {
      //Get tides for new location
      location: function() {
        this.awaitingTodaysData = true;
        this.awaitingMonthData = true;

        this.getTodaysTides();
        this.getChosenMonthsTides();
      },
      inspectMode: function(){
        if(this.inspectMode){
           this.awaitingMonthData = true;
           this.getChosenMonthsTides();
        }
      }
    },
    methods: {
      goToSponsor(){
        // eslint-disable-next-line no-undef
        gtag('event', 
        `Ko-Fi Click`, 
          {
            'event_category': 'Ko-Fi Click'
          }
        );
        window.open('https://ko-fi.com/hightides', '_blank');
      },
      async getTides(starttime, period){

        const res = await fetch(`https://j7hxej6254.execute-api.us-east-1.amazonaws.com/dev?lat=${this.location.latlng[0]}&lng=${this.location.latlng[1]}&starttime=${starttime}&period=${period}`);
        const data = await res.json();

        if(this.isDebug){

          for(let i in data){
            console.log('--------');
            console.log('Day:', i);
            data[i].highs.forEach((item) => {
              console.log(item);
            })
          }
        }

        return data;
      },
      async getTodaysTides(){     
        
        //Get first moment of today
        let now = new Date();
        now = now.setHours(1,0,0,0); 
        now = (now) / 1000; // UTC-1 and UNIX Conversion
        
        let data = await this.getTides(now, 'day');

        let date = new Date();
        let day = date.getDate();

      // TODO: shouldn't be necessary if body is concise
        this.todaysTides = data[day].highs;
        this.awaitingTodaysData = false;
        this.moonPhaseIndex = data[day].moonPhase;
        
      },
      async getChosenMonthsTides(){
        let starttime = this.getFirstMomentofMonth( this.setChosenMonth() );
        let monthIndex = starttime.getMonth();
        starttime = starttime.getTime() / 1000;

        let data = await this.getTides(starttime, 'month');
        
        this.awaitingMonthData = false;
        this.days = data;
        this.startDay = data["1"].weekday;
        this.chosenMonthAsString = this.getMonthName(monthIndex);
      },
      toggleNotes(){
        this.$emit('toggle-notes', null);
      },
      touchstart(event){
        this.initalPos = event.touches[0].clientY;        
      },
      touchmove(event){
        let startPoint = this.inspectMode ? 100 : 81;
        this.deltaY = this.initalPos - event.touches[0].clientY;
        this.deltaY = this.deltaY/window.innerHeight * 100;
        this.dragging = true;
        this.$refs.tidecard.style.height = `${startPoint + (this.deltaY * .5)}vh`;
      },
      touchend(){
        //Cancel if it's just a click
        if(!this.dragging){return}

        //Inspect distance and toggle
        this.dragging = false;
        if(this.deltaY > 10 && !this.inspectMode){
          this.$emit('toggle-inspect', null);
        }
        if(this.deltaY < -10 && this.inspectMode){
          this.$emit('toggle-inspect', null);
        }
        this.$refs.tidecard.style.height = '';
      },
      getTodayAsString(){
        let date = new Date();
        let day = date.getDate();
        const monthIndex = date.getMonth();

        function toOrdinalSuffix(num){
          const int = parseInt(num),
            digits = [int % 10, int % 100],
            ordinals = ['st', 'nd', 'rd', 'th'],
            oPattern = [1, 2, 3, 4],
            tPattern = [11, 12, 13, 14, 15, 16, 17, 18, 19];
            return oPattern.includes(digits[0]) && !tPattern.includes(digits[1])
            ? int + ordinals[digits[0] - 1]
            : int + ordinals[3];
        }

        const months = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ];

        let monthName = months[monthIndex];
        let dayWithSuffix = toOrdinalSuffix(day);

        return `${dayWithSuffix} ${monthName}`;    
      },
      getFirstMomentofMonth(month){
        var d = new Date();
        d.setDate(1);
        d.setMonth(month);
        d.setYear( this.returnCalendarYear() );
        d.setHours(1,0,0,0); // Setting to 0000 caused a bug in September '21 (??)

        return d;
      },
      // Choose month for calendar
      // If last day of month, use next month
      setChosenMonth(){
        
        // Debug override (allows user to set month via query string)
        if(this.getUrlParameter('month')){
          let month = this.getUrlParameter('month');
          month = parseInt(month);
          console.log("Month:", month);

          // Not zero offsetting month for user readibility
          return month -1;
        }

        // Normal function
        var d = new Date();
        let month = d.getMonth();
        let day = d.getDate();

        let lastDayInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        let isLastDay = day == lastDayInMonth[month];

        return isLastDay ? ( (month + 1) % 12 ) : month;
      },
      getMonthName(index){         
        const months = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ];

        return months[index];
      },
      isToday(index){
        var d = new Date(); 
        return d.getDate() === parseInt(index);
      },
      // Returns current year except Dec 
      // when it returns next year
      returnCalendarYear(){

        // Debug override (allows user to set month via query string)
        if(this.getUrlParameter('year')){
          let year = this.getUrlParameter('year');
          year = parseInt(year);
          console.log("Year:", year);

          // Not zero offsetting month for user readibility
          return year;
        }

        var d = new Date();
        var year = d.getYear() + 1900;
        var month = d.getMonth();
        var day = d.getDate();
   
        // Bump to next year if last day
        return month === 11 && day == 31 ? (year + 1) : year; 
      },
      getMoonUrl(index){
        return require(`@/assets/images/moon-${index}.svg`);
      },
      getUrlParameter(name) {
          //eslint-disable-next-line
          name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
          var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
          var results = regex.exec(location.search);
          return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
      }
     },
     data () {
      return {
        isDebug: this.getUrlParameter('debug'),
        awaitingTodaysData: true,
        awaitingMonthData: true,
        days: null, // Holds monthly data
        chosenMonth: this.setChosenMonth(), // Jan (zero count)
        chosenMonthAsString: '',
        startDay: null,
        error: null,
        initalPos: null,
        deltaY: null,
        dragging: null,
        todaysTides: null,
        moonPhaseIndex: 0,
        moonPhases: ['New Moon', 'Waxing Crescent Moon', 'Quarter Moon', 'Waxing Gibbous Moon', 'Full Moon', 'Waning Gibbous Moon', 'Last Quarter Moon', 'Waning Crescent Moon']
      }
    },
  }
</script>

<style lang="scss">
  @import '@/assets/styles/TideCard.scss';
</style>
